import {svgIconWrapper} from '../svg-icon-wrapper';

import RevenueRegular from './revenue-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <RevenueRegular {...props} />;
}
SvgComponent.iconName = 'revenueRegular';

export const RevenueRegularIcon = svgIconWrapper(SvgComponent);
